module.exports = __webpack_public_path__ + "assets/img/pie-low.00e23e31.svg";